import { isEqual } from 'lodash'
import { Reducer } from 'redux'
import { AppAction } from '../types'
import { UiState } from '../types/uiTypes'

const initialState: UiState = {
  mode: 'inspiration',
  inspiration: {
    application: location.hash ? location.hash.substring(1) : '',
    showDetail: undefined
  },
  expert: {
    showApplications: false
  },
  showFinal: false,
  screenSize: {
    width: innerWidth,
    height: innerHeight
  }
}

const uiInspirationReducer: Reducer<UiState, AppAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'Data/Received':
      return {
        ...state,
        inspiration: {
          ...state.inspiration,
          application: action.data.applications.find((x) => x.id === state.inspiration.application)
            ? state.inspiration.application
            : action.data.applications[0].id
        }
      }
    case 'UI/Inspiration/SelectApplication':
      return action.id
        ? {
            ...state,
            inspiration: {
              ...state.inspiration,
              application: action.id,
              lastMovement: action.movementDirection
            }
          }
        : state
    case 'Ui/Inspiration/ShowDetail':
      return {
        ...state,
        inspiration: {
          ...state.inspiration,
          showDetail: action.moduleId
        }
      }
    default:
      return state
  }
}

const uiExpertReducer: Reducer<UiState, AppAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'UI/Expert/ShowPropertyOverlay':
      if (isEqual(state.expert.showProperties, action.payload)) {
        return state
      }
      return {
        ...state,
        expert: {
          ...state.expert,
          showApplications: false,
          showProperties: action.payload
        }
      }
    case 'Configuration/SetModules':
      return state.expert.showProperties
        ? {
            ...state,
            expert: {
              ...state.expert,
              showProperties: undefined
            }
          }
        : state
    case 'UI/Expert/ShowApplicationOverlay':
      return {
        ...state,
        expert: {
          ...state.expert,
          showApplications: action.show,
          showProperties: undefined
        }
      }
    case 'Configuration/TransferToExpertMode':
      return {
        ...state,
        inspiration: {
          ...state.inspiration,
          application: action.applicationId
        }
      }
    default:
      return state
  }
}

const uiGlobalReducer: Reducer<UiState, AppAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'Data/Received': {
      return {
        ...state,
        mode: action.initialMode
      }
    }
    case 'Ui/ShowFinal':
      return {
        ...state,
        showFinal: true,
        expert: {
          ...state.expert,
          showApplications: false,
          showProperties: undefined
        }
      }
    case 'Ui/HideFinal':
      return {
        ...state,
        showFinal: false
      }
    case 'Ui/BodyClick': {
      const hideDetail = !action.ignore.includes('moduleDetail') && !!state.inspiration.showDetail
      const hideExpertProperties =
        !action.ignore.includes('moduleProperties') && typeof state.expert.showProperties?.module === 'number'
      if (hideDetail || hideExpertProperties) {
        return {
          ...state,
          inspiration: hideDetail
            ? {
                ...state.inspiration,
                showDetail: undefined
              }
            : state.inspiration,
          expert: hideExpertProperties
            ? {
                ...state.expert,
                showProperties: undefined
              }
            : state.expert
        }
      }
      return state
    }
    case 'Ui/Escape':
    case 'UI/Inspiration/SelectApplication':
      if (state.showFinal) {
        return {
          ...state,
          showFinal: false
        }
      }
      if (state.mode === 'expert' && (state.expert.showProperties || state.expert.showApplications)) {
        return {
          ...state,
          expert: {
            ...state.expert,
            showProperties: undefined,
            showApplications: false
          }
        }
      }
      if (state.mode === 'inspiration' && state.inspiration.showDetail) {
        return {
          ...state,
          inspiration: {
            ...state.inspiration,
            showDetail: undefined
          }
        }
      }
      return state
    case 'Ui/Resize':
      return {
        ...state,
        screenSize: action.screenSize
      }
    case 'Ui/SetMode': {
      return {
        ...state,
        mode: action.mode
      }
    }
    default:
      return state
  }
}

const uiReducer: Reducer<UiState, AppAction> = (state = initialState, action) => {
  return uiExpertReducer(uiInspirationReducer(uiGlobalReducer(state, action), action), action)
}

export default uiReducer
